module.exports = __webpack_public_path__ + "static/img/home_title_about@2x.0c92d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images2/home_title_about@2x.png
// module id = 6vSA
// module chunks = 1